import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { BoardBasisCode } from '@libs/trip-planner-interfaces';
import { exhaustiveGuard } from '@libs/utils';

const { t } = i18n.global;

export function getBoardBasisText(boardBasis: BoardBasisCode): string {
  switch (boardBasis) {
    case BoardBasisCode.RO:
      return t('filter.boardBasis.no_meals');
    case BoardBasisCode.BB:
      return t('filter.boardBasis.included_breakfast');
    case BoardBasisCode.HB:
      return t('filter.boardBasis.included_half_board');
    case BoardBasisCode['HB+']:
      return t('filter.boardBasis.included_half_board_plus');
    case BoardBasisCode.FB:
      return t('filter.boardBasis.included_full_board');
    case BoardBasisCode.AI:
      return t('filter.boardBasis.all_inclusive');
    default:
      exhaustiveGuard(boardBasis, 'the board basis code is not defined');
  }
}

export function getBoardBasisTextNoIncluded(
  boardBasis: BoardBasisCode
): string {
  switch (boardBasis) {
    case BoardBasisCode.RO:
      return t('filter.boardBasis.no_meals');
    case BoardBasisCode.BB:
      return t('filter.boardBasis.breakfast');
    case BoardBasisCode.HB:
      return t('filter.boardBasis.half_board');
    case BoardBasisCode['HB+']:
      return t('filter.boardBasis.half_board_plus');
    case BoardBasisCode.FB:
      return t('filter.boardBasis.full_board');
    case BoardBasisCode.AI:
      return t('filter.boardBasis.all_inclusive');
    default:
      exhaustiveGuard(boardBasis, 'the board basis code is not defined');
  }
}
